<template>
    <div>
        <b-card no-body>
            <div>
                <b-modal v-model="modalView" no-close-on-backdrop @close="oculta" title="Categorizaicón" centered>
                    <div>
                        <b-form @submit="onSubmit">
                            <b-form-group id="input-group-1" label="Nombre*: " label-for="input-nombre">
                                <b-form-input id="input-nombre" type="text" placeholder="Ingresa Nombre"
                                    v-model="hydraMaquina.nombre" required></b-form-input>
                            </b-form-group>

                            <b-form-checkbox v-if="!creacion" v-model="activo" name="check-button" switch>
                                {{ hydraMaquina.estado==1 ? "Activo" : "Inactivo" }}
                            </b-form-checkbox>
                            <b-button v-if="creacion" type="submit" variant="primary"
                                :disabled="stateProcess == 'PROCESO'">Registrar</b-button>
                            <b-button v-else type="submit" variant="success"
                                :disabled="stateProcess == 'PROCESO'">Actualizar</b-button>

                        </b-form>
                    </div>
                    <template #modal-footer>
                        <div class="w-100">

                            <div v-if="stateProcess == 'ERROR'">
                                <h4 class="float-left">ERROR: {{ message }}</h4>
                            </div>
                            <div v-else-if="stateProcess == 'FIN'">
                                <h5 align="center">{{ message }}</h5>
                            </div>
                            <div v-else-if="stateProcess == 'PROCESO'">
                                <b-progress :value="100" variant="success" striped :animated="true"></b-progress>
                                <div class="text-center">
                                    {{ creacion ? "Registrando..." : "Actualizando..." }}
                                </div>
                            </div>
                            <div v-else>

                            </div>

                        </div>
                    </template>
                </b-modal>
            </div>
        </b-card>



        <b-card no-body>
            <div style="display:block" id="listaPreebarque">




                <div class="row card-body">
                    <div class="col col-sm-12">

                        <b-card-body>
                            <div class="d-flex justify-content-between  flex-wrap">
                                <!-- Registar Preembarque  -->
                                <b-form-group label-for="filterInput" class="mb-0">
                                    <b-button variant="gradient-primary" size="sm" class="mr-1" @click="listar">
                                        <feather-icon icon="RefreshCwIcon" />
                                    </b-button>

                                    <div v-if="show" class="spinner-border text-primary" role="status"
                                        style="width: 1.3rem; height: 1.3rem;">
                                    </div>

                                    &nbsp;
                                    <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="success"
                                        @click="validadEntrada">
                                        <feather-icon icon="PlusIcon" class="mr-50" />
                                        <span class="align-middle">Nuevo</span>
                                    </b-button>
                                    &nbsp;
                                    <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                                        @click="exportExcel">
                                        <feather-icon icon="PlusIcon" class="mr-50" />
                                        <span class="align-middle">Exportar</span>
                                    </b-button>
                                 <!--  
                                    &nbsp;
                                    <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="danger"
                                        @click="validadEntrada">
                                        <feather-icon icon="PlusIcon" class="mr-50" />
                                        <span class="align-middle">Importar</span>
                                    </b-button> -->



                                </b-form-group>
                                <!-- filter -->
                                <b-form-group label-for="filterInput" class="mb-0">
                                    <b-input-group size="sm">
                                        <b-form-input id="filterInput" v-model="filter" type="search"
                                            placeholder="Buscar" />
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">
                                                Borrar
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>

                            </div>
                        </b-card-body>

                        <b-table hover responsive class="position-relative" :per-page="perPage" :current-page="currentPage"
                            :items="items" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                            :sort-direction="sortDirection" :filter="filter" :filter-included-fields="filterOn"
                            @filtered="cPaginacion" :busy="cargando" :bordered="true">


                            <template #cell(accion)="data">
                                <div class="text-nowrap">
                                    <div>
                                       <!--  <b-button size="sm" variant="success" class=""
                                            @click="validadEntradaEdit(data.item)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="feather feather-edit-3">
                                                <path d="M12 20h9"></path>
                                                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
                                            </svg>
                                        </b-button>
                                        &nbsp;&nbsp; -->
                                        <b-button size="sm" variant="danger" class=""
                                            @click="validadEntradaDelete(data.item,0)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="feather feather-trash-2">
                                                <polyline points="3 6 5 6 21 6"></polyline>
                                                <path
                                                    d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2">
                                                </path>
                                                <line x1="10" y1="11" x2="10" y2="17"></line>
                                                <line x1="14" y1="11" x2="14" y2="17"></line>
                                            </svg>
                                        </b-button>
                                    </div>



                                </div>

                            </template>

                            <template #cell(activo)="data">
                                <div class="text-nowrap">
                                    <div>
                                        <div v-if="data.item.estado==1">
                                            <b-badge variant="success"  @click="validadEntradaDelete(data.item,2)">Activo</b-badge>
                                        </div>
                                        <div v-else>
                                            <b-badge variant="danger"  @click="validadEntradaDelete(data.item,1)">Inactivo</b-badge>
                                        </div>
                                    </div>
                                </div>

                            </template>


                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>&nbsp;Carga...</strong>
                                </div>
                            </template>



                        </b-table>

                        <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
                            <!-- page length -->
                            <b-form-group label="Mostrar" label-cols="5" label-align="left" label-size="sm"
                                label-for="sortBySelect" class="text-nowrap mb-md-0 mr-1">
                                <b-form-select id="perPageSelect2" v-model="perPage" size="sm" inline
                                    :options="pageOptions" />

                            </b-form-group>

                            <!-- pagination -->
                            <div>
                                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" first-number
                                    last-number prev-class="prev-item" next-class="next-item" class="mb-0">
                                    <template #prev-text>
                                        <feather-icon icon="ChevronLeftIcon" size="18" />
                                    </template>
                                    <template #next-text>
                                        <feather-icon icon="ChevronRightIcon" size="18" />
                                    </template>
                                </b-pagination>
                            </div>
                        </b-card-body>

                    </div>

                </div>



            </div>

 <!--            <b-modal centered v-model="estadoModal" hide-footer hide-header size="sm">
                <div class="row">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-12 text-center">
                                <feather-icon icon="AlertCircleIcon" size="73em" style="color: #00cfe8;font-size: 100px" />
                            </div>
                            <div class="col-12 text-center"><b style="font-size: 22px">¿Está seguro?</b></div>
                            <br>
                            <div class="col-12">
                                <div class="text-center">¿Desea generar ETL - KSB1 Categorias?</div>
                            </div>
                        </div>

                        <br>
                        <div class="row">
                            <div class="col-12">
                                <div class="text-center">
                                    <b-button v-b-popover="'Popover inside a modal!'" class="btn btn-danger"
                                        title="Cancelar" @click="cerrarModal">Cancelar</b-button>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <b-button v-b-popover="'Popover inside a modal!'" class="btn btn-success"
                                        title="Aceptar">Aceptar</b-button>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>


            </b-modal>
 -->


        </b-card>
    </div>
</template>

<script>

import axiosIns from '@axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import Swal from '../../../libs/sweet-alerts'
import { Spanish } from "flatpickr/dist/l10n/es.js"
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

var  XLSX  =  require("xlsx") ;

import {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BModal,
    VBModal,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    BProgress,
    BFormCheckbox,
    BSpinner,
    BForm
} from 'bootstrap-vue'
import axios from "axios";

export default {

    components: {
        BCard,
        BTable,
        BAvatar,
        BBadge,
        BFormGroup,
        BFormSelect,
        BPagination,
        BInputGroup,
        BFormInput,
        BInputGroupAppend,
        BButton,
        BCardBody,
        BTooltip,
        BModal,
        VBModal,
        BListGroup,
        BListGroupItem,
        BRow,
        BCol,
        vSelect,
        ToastificationContent,
        flatPickr,
        BProgress,
        BFormCheckbox,
        BSpinner,
        BForm
    },
    directives: {
        'b-modal': VBModal,
        Ripple,
    },
    data() {
        return {
            perPage: 5,
            pageOptions: [5, 10, 15],
            totalRows: 1,
            currentPage: 1,
            sortBy: '',
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
            estadoModal: false,
            infoModal: {
                title: '',
                boton: '',
            },
            fields: [
                {
                    key: 'accion',
                    label: 'accion',
                    sortable: true
                },
                {
                    key: 'id',
                    label: 'Codigo',
                    sortable: true
                },
                {
                    key: 'nombre',
                    label: 'Nombre',
                    sortable: true
                },
                {
                    key: 'activo',
                    label: 'Activo',
                    sortable: true
                }
            ],
            items: [],
            status: [
                {
                    1: 'Activo',
                    0: 'Inactivo',
                },
                {
                    1: 'light-success',
                    0: 'light-danger',
                }
            ],
            show: false,
            rangeDate: null,
            cargando: true,
            modalView: false,
            stateClose: false,
            porcentaje: 50,
            totalCC: 100,
            creacion: true,
            stateProcess: "INICIO", // "INICIO" - "PROCESO" - "FIN" - "ERROR"
            hydraMaquina: {
                id: 0,
                nombre: "",
                estado: 0,
                creado: "",
                usuario_creador: 0,
                actualizado: "",
                usuario_actualizado: 0
            },
            message: "",
            activo: true


        }
    },
    computed: {
        sortOptions() {
            // Create an options list from our fields
            return this.fields
                .filter(f => f.sortable)
                .map(f => ({
                    text: f.label,
                    value: f.key
                }))
        },
    },
    mounted() {
        this.listar()
    },

    methods: {

        exportExcel: function () {
            let data = XLSX.utils.json_to_sheet(this.items)
            const workbook = XLSX.utils.book_new()
            const filename = 'hydra_categorizacion'
            XLSX.utils.book_append_sheet(workbook, data, filename)
            XLSX.writeFile(workbook, `${filename}.xlsx`)
           
        },

        oculta(e) {

            if (this.stateClose) {
                e.preventDefault();

                this.$swal.fire(
                    'Proceso en curso',
                    'El Etl se esta ejecutando no se puede detener el proceso.',
                    'warning'
                );
            }
        },

        listar() {
            this.cargando = true;

            const yo = this

            const config = {
                method: 'get',
                url: '/hydra/hydracategorizacions/todos/',
            }

            axiosIns(config)
                .then(function (response) {

                    console.log(response);
                    yo.items = response.data.data;
                    yo.totalRows = yo.items.length
                    yo.cargando = false;
                })
                .catch(function (error) {
                    console.log(error);
                    yo.cargando = false;
                });
        },

        validadEntrada() {

            this.modalView = true;
            this.creacion = true;
            this.stateProcess = "INICIO";
            this.activo = true;
            this.hydraMaquina = {
                id: 0,
                nombre: "",
                estado: 1,
                creado: "",
                usuario_creador: 0,
                actualizado: "",
                usuario_actualizado: 0
            };


        },
        validadEntradaEdit(item) {

            //console.log(item);
            let itemVal = { ...item };
            this.modalView = true;
            this.creacion = false;
            this.stateProcess = "INICIO";
            this.hydraMaquina = itemVal;
            this.activo = itemVal.estado == 1
        },

        validadEntradaDelete(item, valstate) {

            //console.log(item);
            let itemVal = item;
            const me = this

            this.$swal.fire({
                title: valstate == 2 ? '¿Desea desactivar la categorizacion?' :
                    valstate == 1 ? '¿Desea activar la categorizacion?' :
                        '¿Desea eliminar la categorizacion?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Aceptar',
                cancelButtonText: "Cancelar",
                showLoaderOnConfirm: true,
                reverseButtons: true,
                customClass: {
                    confirmButton: 'btn btn-primary ml-1',
                    cancelButton: 'btn btn-outline-danger',
                },
                buttonsStyling: false,
                preConfirm: () => {

                    let maquina = {
                        id: item.id,
                        estado: valstate,
                        usuario_actualizado: item.usuario_actualizado
                    }
                    let url = `/hydra/hydracategorizacion/delete/${maquina.id}`;

                    const config = {
                        method: 'put',
                        url: url,
                        data: maquina
                    }


                    return axiosIns(config)
                        .then(function (response) {
                            console.log(response);
                            let sms = response.data.message_user;
                            let str_status = "success"

                            me.listar();
                            return {
                                'sms': sms,
                                'str_status': str_status
                            }

                        })
                        .catch(function (error) {
                            console.log(error);
                            me.$swal.showValidationMessage(
                                `Error al realizar operacion`
                            )

                        });

                },
                allowOutsideClick: () => !this.$swal.isLoading()
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$swal.fire(
                        '',
                        result.value.sms,
                        result.value.str_status
                    );
                }
            })



        },


        async onSubmit(event) {
            event.preventDefault()


            if (this.hydraMaquina.nombre.trim() == "") {
                this.$swal.fire(
                    'Error',
                    'Debe ingresar todos los campos obligatorios',
                    'error'
                );

                return;
            }
            this.stateProcess = "PROCESO";
            this.stateClose = true;

            let user = JSON.parse(localStorage.getItem("userData"));
            let userID = user.id;// 3
            this.hydraMaquina.usuario_creador = userID;
            this.hydraMaquina.usuario_actualizado = userID;



            let url = this.creacion ? '/hydra/hydracategorizacion/create/' : `/hydra/hydracategorizacion/update/${this.hydraMaquina.id}`;

            this.hydraMaquina.estado = this.activo ? 1: 2;

            const config = {
                method: this.creacion ? 'post' : 'put',
                url: url,
                data: this.hydraMaquina
            }

            try {
                let response = await axiosIns(config);
                if (response.status == 200) {
                    this.message = response.data.message_user;
                    if (response.data.code == 200 && response.data.data.length > 0) {
                        this.stateProcess = "FIN";
                    }
    
                }
                
            } catch (error) {
                this.message = error.response.data.message_user;
                this.stateProcess = "ERROR";
            }

            //this.stateProcess = "ERROR";
            //this.message = "Error al registrar datos";

            this.stateClose = false;

            this.listar();
            if (this.creacion) {
                this.hydraMaquina = {
                    id: 0,
                    nombre: "",
                    estado: 1,
                    creado: "",
                    usuario_creador: 0,
                    actualizado: "",
                    usuario_actualizado: 0
                };
            }
        },

        cPaginacion(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
     /*    cerrarModal() {
            this.estadoModal = false
        }, */


    }

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
  